import { useCallback, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { NEWS } from "../../../../constants/routes";
import CmsPublicApiClient from "../../../../services/api/cmsPublicApiClient";
import { mapNoticiaToListItemVM } from "../../../../services/mappers/cmsPublicMappers";
import { NoticiaListItemVM } from "../../../../types/viewModels/cmsPublic";
import NewsGrid from "../../News/NewsGrid";

const service = new CmsPublicApiClient();
const LATEST_SIZE = 3;

const NewsSection = () => {
  const { t } = useTranslation("news");
  const navigate = useNavigate();
  const [noticias, setNoticias] = useState<NoticiaListItemVM[]>([]);

  // El backend ya ordena por publishedAt descendente, así que la primera página
  // de 3 son las más recientes.
  const fetchLatest = useCallback(async () => {
    try {
      const response = await service.getNoticias({
        page: 1,
        pageSize: LATEST_SIZE,
      });
      setNoticias(response.data.map(mapNoticiaToListItemVM));
    } catch (requestError) {
      // Un fallo acá no debe degradar el Home: la sección simplemente no se muestra.
      setNoticias([]);
    }
  }, []);

  useEffect(() => {
    fetchLatest();
  }, [fetchLatest]);

  if (noticias.length === 0) {
    return null;
  }

  return (
    <div className="w-100 d-flex flex-column align-items-center">
      <div className="w-100 d-flex flex-column align-items-start">
        <h2>{t("latest.title")}</h2>
        <hr className="custom-divider" />
      </div>

      <NewsGrid noticias={noticias} />

      <Button
        className="custom-primary-button mb-5"
        onClick={() => navigate(NEWS)}
      >
        {t("latest.viewAll")}
      </Button>
    </div>
  );
};

export default NewsSection;
